// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapper {
  padding: 5px 35px;
}

.no-border {
  border: none;
  padding: 0;
}

.bold {
  font-weight: 700;
}

.pb-15 {
  padding-bottom: 15px;
}

table {
  width: 100%;
  table-layout: fixed;
}

.receipt-btn {
  color: #125798;
  cursor: pointer;
}

.display-row {
  display: inline-block;
}

.blue-icon {
  color: #125798;
}

.icon-btn {
  display: inline-block;
  border: none;
  background-color: transparent;
}

.receipt-col {
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/campaign-expenditure/campaign-expenditure.component.scss"],"names":[],"mappings":"AAAA;EACI,iBAAA;AACJ;;AAEA;EACI,YAAA;EACA,UAAA;AACJ;;AAEA;EACI,gBAAA;AACJ;;AAEA;EACI,oBAAA;AACJ;;AAEA;EACI,WAAA;EACA,mBAAA;AACJ;;AAEA;EACI,cAAA;EACA,eAAA;AACJ;;AAEA;EACI,qBAAA;AACJ;;AAEA;EACI,cAAA;AACJ;;AAEA;EACI,qBAAA;EACA,YAAA;EACA,6BAAA;AACJ;;AAEA;EACI,kBAAA;AACJ","sourcesContent":[".wrapper {\n    padding: 5px 35px;\n}\n\n.no-border {\n    border: none;\n    padding: 0;\n}\n\n.bold {\n    font-weight: 700;\n}\n\n.pb-15 {\n    padding-bottom: 15px;\n}\n\ntable {\n    width: 100%;\n    table-layout: fixed;\n}\n\n.receipt-btn {\n    color: #125798;\n    cursor: pointer;\n}\n\n.display-row {\n    display: inline-block;\n}\n\n.blue-icon {\n    color: #125798;\n}\n\n.icon-btn {\n    display: inline-block;\n    border: none;\n    background-color: transparent;\n}\n\n.receipt-col {\n    text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
